import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class GWPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {

  // Required / commonly used
category?: string;
  // Optional fields from provider
  officeCode?: string;
  customerCode?: string;

  // Optional security
  tokenSalt?: string;
  url?: string;

  constructor(options?: Partial<GWPaymentProcessorAccountConfiguration>) {
    super(options);
    if (options) {
      Object.assign(this, options);
    }
  }
}